import {TheCage} from "../../TheCage";
import {TheCageGameAssets} from "../../TheCageGameAssets";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {BasicBitmapCountUp} from "../../components/BasicBitmapCountUp";
import {TheCageTextStyles} from "../../config/TheCageTextStyles";
import {TheCageGameMode} from "../../server/TheCageGameMode";
import {gsap} from "gsap";

/**
 * Created by jonas on 2022-11-15.
 */

export class OutroSign extends PIXI.Container{
    get countUp():BasicBitmapCountUp {
        return this._countUp;
    }
    private backgroundImage:PIXI.Sprite;
    private titleText:PIXI.Text;
    private infoText:PIXI.Text;
    private spinsPlayedText:PIXI.Text;
    private _countUp:BasicBitmapCountUp;
    private background: PIXI.spine.Spine;
    private backgrounds: PIXI.spine.Spine[];


    constructor() {
        super();

        //this.backgroundImage = new PIXI.Sprite(PIXI.Texture.EMPTY);
        //this.backgroundImage.anchor.set(0.5,0.5);

        this.backgrounds = [
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.FS_OUTRO_LEV1)),
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.FS_OUTRO_LEV2)),
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.FS_OUTRO_LEV3)),
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.FS_OUTRO_LEV4)),
            new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.FS_OUTRO_LEV5)),
        ];
        this.background = this.backgrounds[0];
        this.addChild(this.background);

        this.infoText = new PIXI.Text("", {
            fill: [
                "#ff5c01"
            ],
            fontFamily: OpenSans.FAMILY,
            fontSize: 25,
            fontWeight: FontWeight.BOLD,
            lineJoin: "round",
            stroke: "#000000",
            strokeThickness: 4
        });
        this.infoText.anchor.set(0.5, 0.5);
        this.infoText.position.set(0, -168);

        this._countUp = new BasicBitmapCountUp(TheCageTextStyles.WIN_COUNT_UP, 1440, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(0, 105);
        this._countUp.scale.set(0.5, 0.5);
        this._countUp.stopAt(0);


        this.spinsPlayedText = new PIXI.Text("", {
            fill: [
                "#fdfbef"
            ],
            fontFamily: OpenSans.FAMILY,
            fontSize: 25,
            fontWeight: FontWeight.REGULAR,
            lineJoin: "round",
            stroke: "#484848",
            strokeThickness: 4
        });
        this.spinsPlayedText.anchor.set(0.5, 0.5);
        this.spinsPlayedText.position.set(0, 160);

        //this.addChild(this.backgroundImage);
        this.addChild(this.infoText);
        this.addChild(this.spinsPlayedText);
        this.addChild(this._countUp);

    }

    public setGraphicsLevel(level:number = 2){
        this.removeChild(this._countUp);
        this.removeChild(this.background);
        this.background.state.setEmptyAnimation(0, 0);
        this.background = this.backgrounds[level];
        this.background.state.setAnimation(0, "Loop", true);
        this.addChild(this.background);
        this.addChild(this._countUp);
    }

    public hideCountUp(): void {
        this._countUp.visible = false;
    }

    public getStill(amount:number): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this._countUp.preCalculateScale(0, amount);
                this._countUp.visible = true;
                this._countUp.alpha = 0;
                this._countUp.stopAt(amount, false);
            })
            .add(gsap.to(this._countUp, {alpha: 1, duration: 0.25}))

    }

    public getCountUp(from:number, to:number): gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this._countUp.preCalculateScale(from, to);
                this._countUp.visible = true;
                this._countUp.alpha = 0;
            })
            .add(gsap.to(this._countUp, {alpha: 1, duration: 0.25}))
            .add(this._countUp.getCountAnimation(from, to, 1), '<0.15');
    }
}